import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, BookOpen } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function Pricing() {
  const handleBuyClick = () => {
    // Fire Meta Pixel AddToCart event
    trackAddToCart({
      content_name: 'Intimidad Sin Presión',
      content_ids: ['53406708138259'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    // Redirect to Shopify cart
    window.open('https://vidasintabu.com/cart/53406708138259:1', '_blank');
  };
  return <Section id="pricing" className="text-center" data-id="element-130">
      <div className="max-w-xl mx-auto bg-white p-8 md:p-12 rounded-sm shadow-xl border border-[#C4A35A]/20 relative overflow-hidden" data-id="element-131">
        {/* Decorative corner */}
        <div className="absolute top-0 right-0 w-20 h-20 bg-[#C4A35A]/10 -mr-10 -mt-10 rounded-full" data-id="element-132"></div>

        <div className="mb-8" data-id="element-133">
          <BookOpen className="w-12 h-12 text-[#C4A35A] mx-auto mb-4" data-id="element-134" />
          <h2 className="text-3xl font-serif text-[#2D2A26] mb-2" data-id="element-135">
            Intimidad Sin Presión
          </h2>
          <p className="text-gray-500 uppercase tracking-widest text-sm" data-id="element-136">
            Edición Digital (PDF)
          </p>
        </div>

        <div className="mb-8" data-id="element-137">
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-138">
            <span className="text-2xl font-serif text-gray-400 line-through" data-id="element-139">
              $27
            </span>
            <span className="bg-[#C4A35A] text-white text-xs font-bold px-2 py-1 rounded-sm uppercase tracking-wide" data-id="element-140">
              -76%
            </span>
          </div>
          <span className="text-5xl font-serif font-bold text-[#2D2A26]" data-id="element-141">
            $6.39
          </span>
          <span className="text-gray-500 ml-2" data-id="element-142">USD</span>
        </div>

        <div className="mb-8 p-4 bg-[#FAF7F2] rounded text-sm text-gray-600 flex items-center justify-center gap-2" data-id="element-143">
          <ShieldCheck className="w-4 h-4 text-[#C4A35A]" data-id="element-144" />
          Una compra única. Lo haces a tu ritmo. En privado.
        </div>

        <Button fullWidth className="text-lg py-5 mb-6" onClick={handleBuyClick} data-id="element-145">
          Quiero el método
        </Button>

        <p className="text-xs text-gray-400" data-id="element-146">
          Acceso inmediato • Pago seguro • Formato PDF
        </p>
      </div>

      <div className="mt-16 max-w-2xl mx-auto" data-id="element-147">
        <p className="text-lg text-gray-700 leading-relaxed" data-id="element-148">
          "Si tu relación está bien 'en lo general' pero se rompió algo en lo
          íntimo… no necesitas más fuerza de voluntad. Necesitas un sistema que
          haga seguro volver a acercarse."
        </p>
        <p className="mt-4 font-serif font-bold text-xl text-[#C4A35A]" data-id="element-149">
          Intimidad Sin Presión es ese sistema.
        </p>
      </div>
    </Section>;
}